import {ProductModel} from '../products/product.model';

export class CartItem {

  product: ProductModel;
  price: number = 0;
  availability: any;
  private _quantity: number = 0;


  constructor(obj: any = {}) {
    this.product = obj && obj.product || new ProductModel();
    this.quantity = obj && obj.quantity || 0;
    this.availability = obj && obj.availability || null;
  }

  get quantity(): number {
    return this._quantity;
  }

  set quantity(value: number) {
    this._quantity = value;
    for (let key in this.product.price) {
      if (this.product.price[key].min_quantity > 0) {
        if (+this._quantity >= +this.product.price[key].min_quantity) {
          this.price = this.product.price[key].cents;
        }
      }
    }
  }
}
